import { jwtDecode } from 'jwt-decode';

export const isSSOlogin = () => localStorage.getItem("ssologin");
export const getTokenDetails = () => JSON.parse(localStorage.getItem('tokenDetails') || '{}');

export const clearStorage = () => {
  localStorage.removeItem('tokenDetails');
  localStorage.removeItem('ssologin');
}

export const getEmailFromToken = () => {
  const tokenDetails = getTokenDetails();
  if (tokenDetails && tokenDetails.accessToken) {
    const accessToken = tokenDetails.accessToken;
    const decoded = jwtDecode(accessToken);
    return isSSOlogin() ? decoded.preferred_username : decoded.email
  }
  return null;
}

export const setAuthToken = (tokenDetails) => {
  if (tokenDetails) {
    localStorage.setItem('tokenDetails', JSON.stringify(tokenDetails));
  } else {
    localStorage.removeItem('tokenDetails');
  }
}